export const PT_System = 1;
export const PT_Org = 2;
export const PT_Setting = 3;
export const PT_Object = 4;
